module.exports = __webpack_public_path__ + "static/media/user-plus.a671f87a.svg";